import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentComponent } from './payment/payment.component';


import { PaymentStatusComponent } from './payment-status/payment-status.component';

const routes: Routes = [
  {
    path: "", redirectTo: "payment", pathMatch: "full"
  },
  {
    path: "payment", component: PaymentComponent    
  },
  {
    path: "payment-status", component: PaymentStatusComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
